import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { BaseCellProps } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { DATA_AUTOMATION_VALUE } from "./const";
import { StyledBaseCell } from "./styles";

type Props = { isChecked: boolean; falseValue?: ReactNode } & Pick<BaseCellProps, "dataAutomation">;

/* TODO move to pro-logic-components cells */
const CheckMarkCell = ({ isChecked, falseValue, dataAutomation }: Props) => {
    return (
        <StyledBaseCell dataAutomation={dataAutomation ?? DATA_AUTOMATION_VALUE}>
            {isChecked ? (
                <SWReactIcons
                    size="xs"
                    iconColor={colorsPalettes.carbon[200]}
                    iconName="checked"
                />
            ) : (
                falseValue
            )}
        </StyledBaseCell>
    );
};

export default CheckMarkCell;
